<template>
  <div class="hilo hilolocal game-table" :id="'hl-' + tableId">
    <div class="game-table-title">
      <div class="row">
        <div class="col-xs-7">
          <h4>
            <i class="fa fa fa-cubes"></i>
            <span class="kind">{{ $t('games.hilo_local') }}</span>
            <!-- <span class="label label-info game-kind">{{ title }}</span> -->
          </h4>
        </div>
        <div class="col-xs-5 game-info text-right">
          <span v-if="round > 0">
            {{ $t('messages.round') }} {{ gameInfo }}
          </span>
          <span v-else>{{ $t('messages.break') }}</span>
        </div>
      </div>
    </div>
    <div class="game-table-detail clearfix">
      <div class="game-table-preview">
        <div class="freeze-record">
          <div class="box-record-wrap dragscroll">
            <div class="box-record-inner" :style="'min-width:' + autoWidth + 'px'" v-if="statistics.dice.length">
              <div class="row-record">
                <div class="col-record" v-for="die in statistics.dice" :key="'stat-point' + die">
                  <i :class="'img-dice dice-14-' + die[0]"></i>
                  <div class="clearfix"></div>
                  <i :class="'img-dice dice-14-' + die[1]"></i><i :class="'img-dice dice-14-' + die[2]"></i>
                </div>
              </div>
              <div class="row-record">
                <div class="col-record" v-for="(winner, i) in statistics.winner" :key="i">
                  <i class="icon-ring-yellow" v-show="winner === 'BIG'"></i>
                </div>
              </div>
              <div class="row-record">
                <div class="col-record" v-for="(winner, i) in statistics.winner" :key="i">
                  <i class="icon-ring-yellow" v-show="winner === 'SMALL'"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="game-table-img">
        <span class="game-kind">{{ title }}</span>
        <img :src="image" width="100" height="100" key="image" v-if="image">
        <img src="//placehold.it/100x100" key="image" v-else>
      </div>
    </div>
    <div class="game-table-sub clearfix">
      <div class="row">
        <div class="col-lg-6 col-xs-5">
          <span>
            {{ $t('messages.bettime', { time: duration }) }}
          </span>
        </div>
        <div class="col-lg-6 col-xs-7 pull-right">
          <!-- Waiting implement -->
        </div>
      </div>
    </div>
    <div class="game-table-bottom clearfix">
      <span class="info">
        <i class="fa fa-info-circle"></i> {{ $t('messages.limit', { limit: betLimit }) }} |
        <i class="fa fa-users"></i> {{ $t('messages.userOnline', { count: online }) }}
      </span>
      <a :href="route" class="btn btn-primary">{{ $t('messages.playNow') }}</a>
    </div>
  </div>
</template>
<script>
  import api from '../../../hilolocal/api'
  export default {
    name: 'game-hilolocal',
    props: {
      user: {
        required: true,
        type: Object
      },
      kind: {
        required: true,
        type: String
      },
      tableId: {
        required: true,
        type: [Number, String]
      }
    },
    data () {
      return {
        config: {},
        stats: {},
        channels: {
          personal: null,
          baccarat: null,
          sessions: null
        },
        statistics: {
          dice: [],
          score: [],
          winner: [],
        },
        betLimit: null
      }
    },
    mounted () {
      this.initialize()
    },
    methods: {
      initialize () {
        api.game.getGameConfigWithInformation(this.tableId,
          (response) => {
            this.config = _.omit(response.data, ['info.detail.statistic'])
            this.stats = _.get(response.data, 'info.detail.statistic', [])
          },
          (error) => {
            // Some api need to force user re-login, because jwt is not work.
            const status = _.get(error, 'response.status')
            if (status === 401) {
              location.href = '/logout'
              return
            }
          }
        )
      }
    },
    computed: {
      autoWidth () {
        const length = this.statistics.score.length
        let width =  length * 45
        width = width > 225 ? width : 225
        if (length > 5) {
          setTimeout(() => {
            $(`#hl-${this.tableId} .box-record-wrap`).animate({
              scrollLeft: width
            }, 1000)
          }, 1000)
        }
        return width
      },
      online () {
        return _.get(this.config, 'info.online')
      },
      duration () {
        return _.get(this.config, 'game.bet_duration')
      },
      gameInfo () {
        const shoe = _.padStart(this.shoe, 4, 0)
        const round =  _.padStart(this.round, 3, 0)
        return `${shoe}-${round}`
      },
      shoe () {
        return _.get(this.config, 'info.detail.shoe')
      },
      round () {
        return _.get(this.config, 'info.detail.round')
      },
      title () {
        return _.get(this.config, 'table.title')
      },
      route () {
        return '/games/live/hilo_local/' + this.tableId
      },
      image () {
        return _.get(this.config, 'dealer.image')
      }
    },
    watch: {
      'user': {
        handler: function (value, old) {
          const game = _.get(value, 'config.games.hilo_local.bet_limit.BIG')
          this.betLimit = `${game.min}-${this.$options.filters.number(game.max)}`
        },
        deep: false
      },
      'stats': {
        handler: function (value, old) {
          const stats = _.takeRight(value, 30)
          _.each(stats, (stat) => {
            const dice = _.split(stat.dice, '.')
            const score = stat.score
            const winner = stat.winner.replace(/x(.*)/i, '')
            this.statistics.dice.push(dice)
            this.statistics.score.push(score)
            this.statistics.winner.push(winner)
          })
        },
        deep: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/games/HiloLocal.vue